import { useTranslations } from 'next-intl';
import { CustomImage as Image } from 'components/shared';
import { BentoHeading, BentoPara } from './StyleConstants';
import styles from './CircadianCard.module.css';

export const CircadianCard = ({ className }: { className?: string }) => {
  const t = useTranslations('ring');
  const tHome = useTranslations('home');
  return (
    <div className={`${styles.root} container${className ? ` ${className}` : ''}`}>
      <BentoHeading>{t('ring.bentoSection.circadianCard.head')}</BentoHeading>
      <BentoPara>
        <b>{t('ring.THE_PHASE_RESPONSE_CURVE')}</b>{' '}
        {t('ring.bentoSection.circadianCard.desc')}
      </BentoPara>
      <Image
        className={styles['circle-image']}
        src="web_v2/illustrations/phase-alignment.png"
        fill
        alt={tHome('home.bentoCards.circadian.alt')}
      />
    </div>
  );
};
